// frontend/landing/src/App.js
import React from "react";
import "./App.css";
import { Button } from "shared-ui";
const APP_NAME = process.env.REACT_APP_APP_NAME || "School Management System";

const PORTALS = [
  {
    id: "admin",
    label: "Admin Portal",
    description:
      "Manage classes, students, teachers, subjects, schedules, and school-wide settings.",
    icon: "👨‍💼",
    url: process.env.REACT_APP_ADMIN_URL || "http://localhost:3020",
    color: "#8b5cf6", // purple
    gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
    shadow: "rgba(139, 92, 246, 0.35)",
    accent: "Administrator",
  },
  {
    id: "teacher",
    label: "Teacher Portal",
    description:
      "Take attendance, grade exams, manage your classes, and track student performance.",
    icon: "👨‍🏫",
    url: process.env.REACT_APP_TEACHER_URL || "http://localhost:3030",
    color: "#3b82f6", // blue
    gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    shadow: "rgba(59, 130, 246, 0.35)",
    accent: "Educator",
  },
  {
    id: "student",
    label: "Student Portal",
    description:
      "View your schedule, grades, exams, and attendance all in one place.",
    icon: "🎓",
    url: process.env.REACT_APP_STUDENT_URL || "http://localhost:3031",
    color: "#10b981", // green
    gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    shadow: "rgba(16, 185, 129, 0.35)",
    accent: "Learner",
  },
];

function App() {
  const handleEnter = (portal) => {
    // Opens in same tab. Change to window.open(portal.url, "_blank")
    // if you'd prefer each portal in a new tab.
    window.location.href = portal.url;
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="landing">
      {/* Decorative blurred orbs */}
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" />

      <div className="landing-content">
        {/* Header */}
        <header className="landing-header">
          <div className="landing-logo">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 3L2 8l10 5 10-5-10-5z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 10.5V16c0 1.5 2.5 3 6 3s6-1.5 6-3v-5.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h1 className="landing-title">{APP_NAME}</h1>
          <p className="landing-subtitle">
            Choose your portal to continue
          </p>
        </header>

        {/* Portal cards */}
        <main className="portal-grid">
          {PORTALS.map((portal) => (
            <Button
              key={portal.id}
              className="portal-card"
              onClick={() => handleEnter(portal)}
              style={{
                "--portal-color": portal.color,
                "--portal-gradient": portal.gradient,
                "--portal-shadow": portal.shadow,
              }}
              aria-label={`Enter ${portal.label}`}
            >
              <div className="portal-card-accent">{portal.accent}</div>

              <div className="portal-icon">{portal.icon}</div>

              <h2 className="portal-label">{portal.label}</h2>
              <p className="portal-description">{portal.description}</p>

              <div className="portal-enter">
                <span>Enter</span>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
            </Button>
          ))}
        </main>

        {/* Footer */}
        <footer className="landing-footer">
          <p>© {currentYear} {APP_NAME}. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default App;